import { TimelineAttachmentMajor } from "@shopify/polaris-icons";
import classNames from "classnames";

import type { MediaFileDataFragment } from "../graphql/types";
import { useMode } from "../hooks/use-mode";

export interface MediaFileProps {
  file: MediaFileDataFragment;
  className?: string;
  visible: boolean;
  prefetch?: boolean;
}

export function MediaFile(props: MediaFileProps) {
  const { file, className, visible, prefetch } = props;

  const mode = useMode();

  if (file.preview_url) {
    const supportsLazyLoading =
      typeof window !== "undefined"
        ? "loading" in HTMLImageElement.prototype
        : false;

    const applySource = visible || prefetch === true;

    return (
      <div
        className={classNames("flex flex-row items-center justify-center", {
          "text-white": mode === "mobile",
          "text-gray-600": mode === "desktop",
        })}>
        <img
          alt={file.alt ?? "file"}
          loading={
            supportsLazyLoading ? (prefetch ? "eager" : "lazy") : undefined
          }
          src={applySource ? (file.preview_url ?? undefined) : undefined}
          width={file.width ?? undefined}
          height={file.height ?? undefined}
          className={classNames(className, "bg-white")}
        />
      </div>
    );
  }

  return (
    <div
      className={classNames("flex flex-row items-center justify-center", {
        "text-white": mode === "mobile",
        "text-gray-600": mode === "desktop",
      })}>
      <TimelineAttachmentMajor
        aria-hidden="true"
        fill="currentColor"
        width={32}
        height={32}
      />
    </div>
  );
}
